import { useEffect } from 'react';
import { setProp } from '@tcp/core/src/analytics/utils';
import {
  internalCampaignProductAnalyticsList,
  fireEnhancedEcomm,
  internalPromotionFormattedProducts,
} from '@tcp/core/src/utils/index';
import pushEventToAdobeAnalytics, {
  getPLPPageName,
} from '../../../../../../adobeAnalytics/adobe.utils';
import {
  getAnalyticsFormatedProductsEE,
  getCategoryListingPageTrackData,
  getIcidValue,
  trackAnalyticsChange,
  getIcidWithPromoFilterSlot,
  getSearchAnalyticsData,
} from '../analyticsHelper';

const getIcid = (icid, isFromHplp) => {
  let updatedIcid = icid;
  if (isFromHplp) {
    let icidFromHplp = icid?.split('plp_s');
    if (icidFromHplp.length > 1) {
      icidFromHplp = `hplp_s${icidFromHplp?.[1]}`;
      updatedIcid = icidFromHplp;
    }
  }
  return updatedIcid;
};
function sendAdobePageViewEvent(pageDataAdobe, User, APIConfig, session) {
  return new Promise((resolve) => {
    pushEventToAdobeAnalytics('page_view', { pageData: pageDataAdobe, User, APIConfig, session });
    resolve();
  });
}

const trackAdobePageView = (
  processedBreadCrumbs,
  User,
  APIConfig,
  session,
  asPath,
  productsFormattedEE,
  promotionalProducts
) => {
  const pageName = getPLPPageName(processedBreadCrumbs);
  const pageDataAdobe = {
    pageName,
    pageSection: processedBreadCrumbs?.[1]?.displayName,
    pageSubSection: processedBreadCrumbs?.[2]?.displayName,
    pageSubSection2: processedBreadCrumbs?.[3]?.displayName,
    pageType: 'product listing page',
    pagination: asPath?.split('page=')?.[1],
  };
  sendAdobePageViewEvent(pageDataAdobe, User, APIConfig, session).then(() => {
    pushEventToAdobeAnalytics('product_impression', {
      productImpressions: productsFormattedEE,
      pageView: { pageData: pageDataAdobe, User, APIConfig, session },
    });
    pushEventToAdobeAnalytics(
      'promotional_banner_impression',
      internalPromotionFormattedProducts(promotionalProducts)
    );
  });
};

function useClpAnalytics({
  paginatedProducts,
  router,
  isNewNavigationImagesEnabled,
  appliedFilters,
  totalProductsCount,
  processedBreadCrumbs,
  trackPageLoad,
  currency,
  appliedSort,
  storeId,
  defaultStoreId,
  isInitialCall,
  isTopRatedBackAbEnabled,
  isBestSellerBackAbEnabled,
  pageNumber,
  isHideOriginalPriceAndMarchantTagEnabled,
  setFromHplpFlag,
  isFromHplp,
  isMostFavoritedBadgeEnabled,
  User,
  APIConfig,
  session,
  promotionsData,
}) {
  const { currentProducts } = trackAnalyticsChange({
    paginatedProducts,
    appliedFilters,
  });

  const analyticsCall = () => {
    if (paginatedProducts.length > 0 && !isInitialCall && currentProducts) {
      const {
        query: { shopall },
        asPath,
      } = router;

      const promotionalProducts = internalCampaignProductAnalyticsList();
      const productsFormattedEE = getAnalyticsFormatedProductsEE({
        paginatedProducts,
        breadcrumbs: processedBreadCrumbs,
        currency,
        isTopRatedBackAbEnabled,
        isBestSellerBackAbEnabled,
        isHideOriginalPriceAndMarchantTagEnabled,
        isMostFavoritedBadgeEnabled,
        promotionsData,
      });

      setProp('eVar30', paginatedProducts.length);
      const icid = getIcidValue(router && router.asPath);
      const viaPromoFilterIcid = getIcidWithPromoFilterSlot(router, processedBreadCrumbs, 'plp');
      let categoryListingPageTrackerData = getCategoryListingPageTrackData({
        isNewNavigationImagesEnabled,
        appliedFilters,
        paginatedProducts,
        totalProductsCount,
        breadcrumbs: processedBreadCrumbs,
        router,
        storeId: storeId || defaultStoreId,
        icid,
        appliedSort,
        shopall,
      });

      if (viaPromoFilterIcid) {
        categoryListingPageTrackerData.customEvents = ['event91', 'event81'];
        categoryListingPageTrackerData.internalCampaignId = viaPromoFilterIcid;
      }

      if (icid) {
        categoryListingPageTrackerData.customEvents = ['event91', 'event92', 'event81', 'event80'];
        categoryListingPageTrackerData.pageNavigationText = '';
        categoryListingPageTrackerData.departmentList = '';
        categoryListingPageTrackerData.pageSearchType = '';
        categoryListingPageTrackerData.internalCampaignId = getIcid(icid, isFromHplp);
      }
      if (pageNumber && !icid) {
        categoryListingPageTrackerData.plpPaginationcd153 = `${categoryListingPageTrackerData?.pageNavigationText}|page${pageNumber}`;
      }
      categoryListingPageTrackerData = getSearchAnalyticsData(
        categoryListingPageTrackerData,
        asPath,
        productsFormattedEE,
        totalProductsCount
      );
      setTimeout(() => {
        trackPageLoad(categoryListingPageTrackerData);
      }, 100);
      setFromHplpFlag(false);
      fireEnhancedEcomm({
        eventName: 'productimpression',
        productsObj: productsFormattedEE,
        eventType: 'impressions',
        pageName: categoryListingPageTrackerData.pageName || 'PLP',
        currCode: currency,
        eventLabel: 'Product impression',
      });
      if (promotionalProducts) {
        fireEnhancedEcomm({
          eventName: 'internalcampaignimpression',
          productsObj: internalPromotionFormattedProducts(promotionalProducts),
          eventType: 'promoView',
          pageName: categoryListingPageTrackerData.pageName || 'PLP',
          currCode: 'USD',
        });
      }
      trackAdobePageView(
        processedBreadCrumbs,
        User,
        APIConfig,
        session,
        asPath,
        productsFormattedEE,
        promotionalProducts
      );
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      analyticsCall();
    }, 1);
    return () => clearTimeout(timer);
  }, [currentProducts, isInitialCall]);
}

export default useClpAnalytics;
